import { ModuleWithProviders } from '@angular/core/src/metadata/ng_module';
import { Routes, RouterModule } from '@angular/router';

import { CategoryComponent } from './category/category.component';
import { LeaderboardComponent } from './leaderboard/leaderboard.component';
import { SettingsComponent } from './settings/settings.component';
import { QuibblInspectorComponent } from './category/quibbl-inspector/quibbl-inspector.component';
import { HomeComponent } from './home/home.component';
import { LoginComponent } from './login/login.component';
import { QuibblDiscussionComponent } from './category/quibbl-inspector/quibbl-discussion/quibbl-discussion.component';
import { QuibblRelatedComponent } from './category/quibbl-inspector/quibbl-related/quibbl-related.component';
import { QuibblVotesComponent } from './category/quibbl-inspector/quibbl-votes/quibbl-votes.component';
import { ProfileComponent } from './profile/profile.component';
import { AdminComponent } from './admin/admin.component';
import { ReviewComponent } from './review/review.component';
import { TodayComponent } from './today/today.component';

import { AboutComponent } from './about/about.component';
import { TermsComponent } from './terms/terms.component';
import { ContactComponent } from './contact/contact.component';
import { MarchMadnessComponent } from './march-madness/march-madness.component';

export const ROUTES: Routes = [
    {
      path: '',
      redirectTo: 'home',
      pathMatch: 'full'
    },
    {
      path: 'login',
      component: LoginComponent
    },
    {
      path: 'marchmadness',
      component: MarchMadnessComponent
    },
    {
      path: 'home',
      component: HomeComponent
    },
    {
      path: 'settings',
      component: SettingsComponent
    },
    {
      path: 'about',
      component: AboutComponent
    },
    {
      path: 'terms',
      component: TermsComponent
    },
    {
      path: 'contact',
      component: ContactComponent
    },
    {
      path: 'leaderboard',
      component: LeaderboardComponent
    },
    {
      path: 'profile/:profileId',
      component: ProfileComponent
    },
    {
      path: 'admin',
      component: AdminComponent,
      children: [
        {
          path: '',
          component: TodayComponent,
        },
        {
          path: 'review',
          component: ReviewComponent,
        }
      ]
    },
    {
      path: 'category/:categoryId',
      component: CategoryComponent,
      children: [
        {
          path: ':quibblId',
          component: QuibblInspectorComponent,
          children: [
            {
              path: '',
              component: QuibblVotesComponent
            },
            {
              path: 'discussion',
              component: QuibblDiscussionComponent
            },
            {
              path: 'related',
              component: QuibblRelatedComponent
            }
          ]
        }
      ]
    }
];

export const ROUTING: ModuleWithProviders = RouterModule.forRoot(ROUTES);



// WEBPACK FOOTER //
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/app.routing.ts